import { Subscription } from "rxjs";
import { v4 as uuidv4 } from 'uuid';
import { AppErrorMessageEvent, AppInfoMessageEvent, AppSuccessMessageEvent } from "../../app-events";
import { AppState } from "../../app-state";
import { TestbedRxdbError } from "./testbed-rxdb-error";


// base class for all couchdb and graphql rxdb collections
export abstract class TestbedCollectionService<DocumentType> {

    constructor( public appState: AppState ) {

    }

    timestamp(date: Date): string {
        return date.toISOString();
    }

    nowTimeStamp(): string {
        return this.timestamp(new Date())
    }

    generateId() : string {
        return uuidv4()
    }

    publishError(error: any, source: any, expireSecs = AppErrorMessageEvent.DEFAULT_EXPIRE_SECS): string {
        let errMsg = this.extractErrorMsg(error)
        return this.appState.publishErrorObj(error,errMsg,source,expireSecs)
    }

    publishErrorObj(error: any, title: string, source: any, expireSecs = AppErrorMessageEvent.DEFAULT_EXPIRE_SECS): string {
        let errMsg = title || this.extractErrorMsg(error)
        return this.appState.publishErrorObj(error,errMsg,source,expireSecs)
    }

    publishSuccess(msg: string, source: any, expireSecs = AppSuccessMessageEvent.DEFAULT_EXPIRE_SECS): string {
        this.appState.successEmitter.next(new AppSuccessMessageEvent(msg, source, expireSecs))
        return msg
    }

    publishInfo(msg: string, source: any, expireSecs = AppInfoMessageEvent.DEFAULT_EXPIRE_SECS): string {
        this.appState.infoEmitter.next(new AppInfoMessageEvent(msg, source, expireSecs))
        return msg
    }

    extractErrorMsg(error: any): string {
        return TestbedRxdbError.extractMsg(error)
    }

    doWhenReady( readyFn : () => void ) : Subscription {
        return this.appState.doWhenReady( readyFn )
    }

    abstract getById(id:string) : Promise<DocumentType>;

}